function getRaf() {
  return typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout;
}
function getCancelRaf() {
  return typeof window !== "undefined" && window.cancelAnimationFrame ? window.cancelAnimationFrame.bind(window) : clearTimeout;
}
function nextFrame(fn) {
  return new Promise((resolve) => {
    getRaf()(() => resolve(typeof fn === "function" && fn()));
  });
}
export {
  nextFrame as default,
  getCancelRaf,
  getRaf
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
